/*  ========================================================================
    # Scripts - Hero Video Lightbox
    ========================================================================  */

/**
 * Script that handles the marquee logic of the social proof section (variant 9.0).
 */
const HeroVideoLightbox = {
  cfg: {
    sections: document.querySelectorAll('.s-hero[data-variant="4.8"], .s-hero[data-variant="4.9"]'),
    selectors: {
      lightboxWrapper: '.s-hero__video-lightbox',
      lightboxTrigger: '.s-hero__video-lightbox-trigger',
      lightboxClose: '.s-hero__video-lightbox-close',
      lightboxDialog: '.s-hero__video-lightbox-dialog'
    }
  },

  handleVideoLightbox(section) {
    const lightboxWrapper = section.querySelector(this.cfg.selectors.lightboxWrapper);
    if (!lightboxWrapper) return;

    const lightboxTrigger = lightboxWrapper.querySelector(this.cfg.selectors.lightboxTrigger);
    const lightboxClose = lightboxWrapper.querySelector(this.cfg.selectors.lightboxClose);
    const lightboxDialog = lightboxWrapper.querySelector(this.cfg.selectors.lightboxDialog);

    // Open lightbox
    lightboxTrigger.addEventListener('click', () => {
      lightboxWrapper.classList.add('is-open');
      lightboxDialog.showModal();

      // Set Src for video
      const video = lightboxDialog.querySelector('video[data-src]');
      if (video && video.dataset.src) {
        video.src = video.dataset.src;
        video.removeAttribute('data-src');
      }
    });

    lightboxClose.addEventListener('click', () => {
      lightboxDialog.close();
    });

    lightboxDialog.addEventListener('close', () => {
      lightboxWrapper.classList.remove('is-open');

      // Pause video
      const video = lightboxDialog.querySelector('video');
      if (video) {
        video.pause();
      }
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.sections) {
      this.cfg.sections.forEach(section => {
        this.handleVideoLightbox(section);
      });
    }
  }
};

export default HeroVideoLightbox;
